export default "<div id=\"hc-scatter\"></div>\n";